import { render, staticRenderFns } from "./fright_append.vue?vue&type=template&id=2f69538e&scoped=true&"
import script from "./fright_append.vue?vue&type=script&lang=js&"
export * from "./fright_append.vue?vue&type=script&lang=js&"
import style0 from "./fright_append.vue?vue&type=style&index=0&id=2f69538e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f69538e",
  null
  
)

export default component.exports